import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader, getCurrentYear } from "../Helpers";

export default function Footer(props) {
	const appContext = useContext(AppContext);
	const [ready, setReady] = useState(false);

	async function init() {
		setReady(false);
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	if (ready) {
		return (
			<div
				className="MainBodySection bg-dark"
				style={{
					paddingBottom: "20px",
					paddingTop: "50px",
					borderTop: "1px solid var(--secondaryColor)",
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-4">
							<h6 className="main-section-title text-start">Useful Links</h6>

							<h6
								style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => {
									appContext.navTo({ item: "" });
								}}
								className="btn font-bold text-light"
							>
								Home
							</h6>

							<h6
								style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => {
									appContext.navTo({ item: "about_us" });
								}}
								className="font-bold text-light"
							>
								About Us
							</h6>

							<h6
								style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => {
									appContext.navTo({ item: "subsidiaries" });
								}}
								className="font-bold text-light"
							>
								Subsidiaries
							</h6>

							<h6
								style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => {
									appContext.navTo({ item: "contact_us" });
								}}
								className="font-bold text-light"
							>
								Contact Us
							</h6>
						</div>

						<div className="col-md-4">
							<h6 className="main-section-title text-start">Address</h6>
							<h6 style={{ fontSize: "14px", padding: "10px" }} className="font-bold text-light">
								Dar es Salaam
							</h6>
						</div>

						<div className="col-md-4">
							<h6 className="main-section-title text-start">Reach Out</h6>
							<h6 style={{ fontSize: "14px", padding: "10px" }} className="font-bold text-light">
								Email: <span>info@ndomanogroup.com</span>
								<br />Phone: <span> +255 772 162 151 | +255 749 487 578 </span>
							</h6>
						</div>

						<div className="col-md-12 text-center font-bold">
							<h6 style={{ fontSize: "14px", paddingTop: "30px" }} className="text-light">
								&copy; Ndomano Group of Companies - {getCurrentYear()}
							</h6>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="container mSupportLoading">{getInlineLoader()}</div>
	);
}